import { render, staticRenderFns } from "./MembersExpired.vue?vue&type=template&id=01520279&scoped=true&lang=html&"
import script from "./MembersExpired.vue?vue&type=script&lang=js&"
export * from "./MembersExpired.vue?vue&type=script&lang=js&"
import style0 from "./MembersExpired.vue?vue&type=style&index=0&id=01520279&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01520279",
  null
  
)

export default component.exports